import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import blue from "@material-ui/core/colors/blue";
import ErrorOutline from "@material-ui/icons/ErrorOutline";

const ErrorScreen = memo(() => {
  const { t } = useTranslation();
  return (
    <Box
      position="absolute"
      left="50%"
      top="50%"
      style={{ transform: "translate(-50%, -50%)" }}
    >
      <Grid container direction="column">
        <Box width="100%" textAlign="center">
          <ErrorOutline color="error" style={{ fontSize: "6rem" }} />
        </Box>
        <Typography variant="h3">{t("error:crash")}</Typography>
        <Grid container direction="row" alignItems="baseline">
          <Typography>{t("error:try")}</Typography>
          &nbsp;
          <Button
            onClick={() => window.location.reload()}
            style={{
              textTransform: "lowercase",
              padding: 0,
              color: blue[400],
            }}
          >
            <Typography>{t("common:refreshing")}</Typography>
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
});

export default ErrorScreen;
